import { PaymentMethod } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint } from '@aibees/shared/workspace';
import { usePaymentMethodUpdateSocketListener } from '../socket/use-payment-method-update-socket-listener';
import { BrowsePaymentCardRequest, BrowsePaymentCardResponse } from './types';

export function useBrowsePaymentCardApi() {
  const endpoint = useCustomerEndpoint('paymentMethod');

  usePaymentMethodUpdateSocketListener();

  return useBaseQuery<
    BrowsePaymentCardRequest,
    PaymentMethod[],
    BrowsePaymentCardResponse
  >(
    [useBrowsePaymentCardApi.name],
    {
      url: endpoint,
      params: { return: 'list' },
    },
    {
      select: (data) => ({
        content: data ?? [],
        totalElements: data?.length ?? 0,
      }),
    }
  );
}
